import React, { useEffect, useState } from 'react'
import { AlertError } from '../../components'
import { Form, Sidebar } from './components'
import { useHistory } from 'react-router-dom'
import { createBlog, fetchBlog, updateBlog } from '../../features/blog/slice'
import { useDispatch, useSelector } from 'react-redux'
import { setStatus } from '../../features/blogs/slice'
import { reset } from '../../features/blog-form/slice'
import { toast } from 'react-toastify'

const DashboardBlogForm = ({ match }) => {
  const dispatch = useDispatch()
  const id = match.params.id
  const history = useHistory()
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const isEdit = id && id !== undefined && id !== null
  const blogForm = useSelector(state => state.blogForm.data)
  const [showForm, setShowForm] = useState(false)

  // If route params ID exists, get the data
  useEffect(() => {
    if (isEdit && id) {
      dispatch(fetchBlog(id))
    } else {
      console.log('reset')
      dispatch(reset())
      setTimeout(() => {
        setShowForm(true)
      }, 500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(blogForm && blogForm.id && showForm === false){
      setShowForm(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogForm])

  const isValid = () => {
    let result = true
    let msg = ''

    // Insert rules here...

    if(msg !== ''){
      setErrorMessage(msg)
    }

    return result
  }

  function handleCreate(e) {
    let finalForm = {...blogForm}

    // Handle 'draft' status
    if(e.submission){
      finalForm.submission = e.submission
    }

    dispatch(createBlog(finalForm))
      .then(res => {
        if(res.error && res.error.message){
          console.log(res.error)
          setErrorMessage(JSON.stringify(res.error.message))
          toast.error('Error.')
        } else {
          console.log(res)
          toast.success('Blog successfully created!')
          dispatch(setStatus('idle'))
          history.push('/dashboard/blog')
        }
      })
      .catch(err => {
        console.log(err)
        setErrorMessage(err)
        toast.error('Error.')
      })
      .then(() => setRequesting(false))
  }

  function handleEdit(e) {
    let finalForm = {...blogForm}

    // Handle 'draft' status
    if(e.submission){
      finalForm.submission = e.submission
    }

    dispatch(updateBlog({id, form: finalForm}))
      .then(res => {
        console.log(res)
        toast.success('Blog successfully updated!')
        dispatch(setStatus('idle'))
        history.push('/dashboard/blog')
      })
      .catch(err => {
        console.log(err)
        setErrorMessage(err)
        toast.error('Error.')
      })
      .then(() => setRequesting(false))
  }

  const handleSubmit = (e) => {
    if(e.preventDefault){
      e.preventDefault()
    }

    setRequesting(true)
    setErrorMessage(null)

    if(isValid()){
      if(isEdit){
        handleEdit(e)
      } else {
        handleCreate(e)
      }
    } else {
      setRequesting(false)
    }
  }

  return (
    <>
      {
        errorMessage &&
        <div className="mb-8">
          <AlertError
            message={errorMessage}
            onClose={() => setErrorMessage(null)}
          />
        </div>
      }

      {
        showForm &&
        <form className="flex flex-wrap -mx-4" onSubmit={handleSubmit}>
          <div className="w-full lg:w-2/3 pl-4 pr-4 lg:pr-8">
            <Form isEdit={isEdit}/>
          </div>
          <div className="w-full lg:w-1/3 px-4">
            <Sidebar requesting={requesting} isEdit={isEdit} handleSubmit={handleSubmit}/>
          </div>
        </form>
      }
    </>
  )
}

export { DashboardBlogForm }
